import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M512 768a256 256 0 00255.602-241.778H768v-28.444h-.398a256 256 0 00-511.204 0H256v28.444h.398A256 256 0 00512 768zm58.169-35.954c31.602-42.382 53.305-118.243 55.438-205.824H739.1A227.698 227.698 0 01570.17 732.046zM453.83 291.954c-31.602 42.382-53.305 118.243-55.438 205.824H284.9A227.698 227.698 0 01453.83 291.954zm-26.994 205.824c1.593-61.81 13.37-116.281 30.72-155.25 9.302-20.992 19.684-36.21 29.753-45.796 9.956-9.472 18.233-12.288 24.69-12.288 6.457 0 14.734 2.845 24.69 12.288 10.07 9.586 20.451 24.804 29.781 45.796 17.294 38.969 29.099 93.44 30.692 155.25H426.837zm0 28.444h170.326c-1.593 61.81-13.37 116.281-30.72 155.25-9.302 20.992-19.684 36.21-29.753 45.796-9.956 9.472-18.233 12.288-24.69 12.288-6.457 0-14.734-2.845-24.69-12.288-10.07-9.586-20.451-24.804-29.781-45.796-17.294-38.969-29.099-93.44-30.692-155.25zm-28.444 0c2.133 87.61 23.836 163.442 55.438 205.824a227.698 227.698 0 01-168.96-205.824h113.522zm227.214-28.444c-2.133-87.61-23.836-163.442-55.438-205.824a227.698 227.698 0 01168.96 205.824H625.607z"
});

function SvgGlobal(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "global_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'GlobalOutlined';

export default KuFoxIcons;
